import { useMutation } from "@tanstack/react-query";
import { api, endpoints, useAuthStore } from "@vixi/api";
import { ConfirmEmailParams } from "@vixi/types";

export const useConfirmEmail = () => {
  const { registeringUser, clearRegisteringUser: clearRegisteringUser } = useAuthStore();

  const mutation = useMutation({
    mutationKey: ["confirm-email"],
    mutationFn: async (code: string) => {
      if (!registeringUser) {
        throw new Error("No registering user found");
      }

      const params: ConfirmEmailParams = {
        email: registeringUser.email,
        OTP: code,
      };
      await api.get(endpoints.confirmEmail, { params });

      clearRegisteringUser();
    },
  });

  return mutation;
};
